export default {"src":"/_next/static/media/employers-icon.6b452db9.svg","height":89,"width":88,"blurWidth":0,"blurHeight":0};